import React from "react";

const SECTIONS = [
  ["Use of Service", "You agree to use this service only for lawful purposes and in accordance with these Terms."],
  ["No Warranty", "The service is provided \"as is\" without warranties of any kind, express or implied."],
  ["Limitation of Liability", "We are not liable for any damages arising from the use of this service."],
  ["Changes", "We may update these terms at any time without notice. Continued use constitutes acceptance."],
  ["Contact", "For any questions about these Terms, contact us at support@simpleinvoice.com."],
];

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold mb-3">Legal</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">Terms & Conditions</h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated: February 5, 2026</p>
        <p className="mt-6 text-muted-foreground leading-relaxed">Please read these terms carefully before using our service.</p>
      </div>
      <div className="space-y-8">
        {SECTIONS.map(([t, d], i) => (
          <section key={t}>
            <h2 className="font-heading text-lg font-semibold">{i + 1}. {t}</h2>
            <p className="mt-2 text-muted-foreground leading-relaxed">{d}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
